import { loanPipelinesApi } from 'app/services/api';

import { HTTP_RESPONSE_STATUS_CODES } from 'constants/http';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { selectPipelineStats, selectRawLoanPipelineById } from 'store/loanPipelines/selectors';

export const PIPELINE_STATS_ACTION_TYPE = createNamedActions('loanPipelines', {
  FETCH_PIPELINE_STATS: 'FETCH_PIPELINE_STATS',
  FETCH_PIPELINE_STATS_SUCCESS: 'FETCH_PIPELINE_STATS_SUCCESS',
  FETCH_PIPELINE_STATS_FAILURE: 'FETCH_PIPELINE_STATS_FAILURE',
});

export const fetchPipelineStatsAction = catchAsyncActionError(pipelineId => async dispatch => {
  dispatch({
    type: PIPELINE_STATS_ACTION_TYPE.FETCH_PIPELINE_STATS,
    payload: { pipelineId },
  });

  try {
    const { data } = await loanPipelinesApi.getPipelineStats({ loanPipelineId: pipelineId });

    return dispatch({
      type: PIPELINE_STATS_ACTION_TYPE.FETCH_PIPELINE_STATS_SUCCESS,
      payload: { pipelineId, data },
    });
  } catch (error) {
    dispatch({
      type: PIPELINE_STATS_ACTION_TYPE.FETCH_PIPELINE_STATS_FAILURE,
      payload: {
        pipelineId,
        error,
        isNotFound: error?.response?.status === HTTP_RESPONSE_STATUS_CODES.NOT_FOUND,
      },
    });

    throw error;
  }
});

// SignalR pipeline events fire for any pipeline the connection is subscribed to — including
// ones absent from this session's list (another company's pipeline) or with no stat widgets.
// Fetching stats for those 404s forever (DEV-5718). Only fetch when the pipeline is in the
// store AND has widgets (mirrors PipelineStatsBar), and never re-fetch an id that already
// 404'd this session (circuit-breaker).
export const fetchPipelineStatsIfEligibleAction = pipelineId => (dispatch, getState) => {
  const state = getState();
  const pipeline = selectRawLoanPipelineById(pipelineId)(state);

  if (!pipeline?.widgetConfiguration?.widgets?.length) {
    return;
  }

  if (selectPipelineStats(pipelineId)(state).isNotFound) {
    return;
  }

  return dispatch(fetchPipelineStatsAction(pipelineId));
};
